import React, { SyntheticEvent, useState } from "react";

import CloseIcon from "@mui/icons-material/Close";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import PermMediaOutlinedIcon from "@mui/icons-material/PermMediaOutlined";
import { Container, IconButton, Tab, Tabs } from "@mui/material";

import FullScreenLayout from "../layout/FullScreenLayout";
import OrganizationDocuments from "./OrganizationDocuments";
import OrganizationMedia from "./OrganizationMedia";

import { MediaHeader, MediaHeading } from "./OrganizationMedia.style";
import { useTranslation } from "hhn-commons";

type OrganizationMediaBaseProps = {
  closeModal: () => void;
};

enum OrganizationTab {
  Media = "media",
  Documents = "documents",
}

const OrganizationMediaBase = ({ closeModal }: OrganizationMediaBaseProps) => {
  const { t } = useTranslation();
  const tNs = (key: string) => t(key, { ns: "organizationMedia" });
  const [selectedTab, setSelectedTab] = useState<OrganizationTab>(
    OrganizationTab.Media,
  );

  const handleTabChange = (_: SyntheticEvent, value: OrganizationTab) => {
    setSelectedTab(value);
  };

  return (
    <FullScreenLayout>
      <Container maxWidth="xl">
        <MediaHeader>
          <MediaHeading variant="h5">{tNs("organizationMedia")}</MediaHeading>

          <IconButton
            onClick={closeModal}
            data-testid="close-organization-media"
          >
            <CloseIcon />
          </IconButton>
        </MediaHeader>

        <Tabs value={selectedTab} onChange={handleTabChange} sx={{ mb: 3 }}>
          <Tab
            value={OrganizationTab.Media}
            label={tNs("imagesVideos")}
            icon={<PermMediaOutlinedIcon />}
            iconPosition="start"
          />

          <Tab
            value={OrganizationTab.Documents}
            label={tNs("documents")}
            icon={<DescriptionOutlinedIcon />}
            iconPosition="start"
          />
        </Tabs>

        {selectedTab === OrganizationTab.Media && <OrganizationMedia />}

        {selectedTab === OrganizationTab.Documents && <OrganizationDocuments />}
      </Container>
    </FullScreenLayout>
  );
};

export default OrganizationMediaBase;
